import { XmlElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Xml extends XmlElement {}
export default Xml;